import styled from "@emotion/styled";
//eslint-disable-file: MAJOR TODO - FIX ESLINT BREAKING ON THEME TYPE
interface ModalContentProps {
  backgroundColor?: "main" | "alt";
}

export const ModalContent = styled.div<ModalContentProps>`
  max-width: 473px;
  width: 100%;
  color: white;
  background: ${({ theme, backgroundColor }) =>
    backgroundColor === "main" || backgroundColor == null
      ? theme.surface.main.primary.default
      : theme.surface.alt.secondary.default};
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  margin: auto;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  outline: 0;
`;
